export default {
  "content": "<path fill-rule=\"evenodd\" d=\"M45.36 1.16a3 3 0 014.24 0 3.02 3.02 0 010 4.21L32.62 22.4l-4.25-4.25L45.36 1.16zm-31.9 36.13L.89 24.71a3.04 3.04 0 010-4.28 3 3 0 014.25 0l14.7 14.76-2.12 2.1a3 3 0 01-4.24 0zm20.96.72a3.03 3.03 0 01-.2.2 2.97 2.97 0 01-4.2 0l-12.4-12.4a2.97 2.97 0 014.2-4.2l10.3 10.3L62.16 1.87a2.97 2.97 0 014.2 4.2L34.42 38.01z\" clip-rule=\"evenodd\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "68",
    "height": "40",
    "viewBox": "0 0 68 40"
  }
};